'use strict';

var GridSystemSaveButtonDirective = function GridSystemSaveButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-system-save-button.html'),
    controller: 'GridSystemSaveButtonController'
  };
};
GridSystemSaveButtonDirective.$inject = [];
module.exports = GridSystemSaveButtonDirective;